<template>
    <div id="mobile-nav"
         :class="{'solid': this.showSolid,
                  'dropped': this.dropped && this.menuState === 0}">
        <div id="nav-header">
            <button id="toggle-button" class="button flat-button"
                    @click="toggleClicked">
                <span v-if="menuState === 0">𝝣</span>
                <span v-else>◃</span>
            </button>
            <img alt="MOCO Ink logo"
                 src="../assets/logo.png"
                 v-if="navTitle === ''"/>
            <span v-else>{{navTitle}}</span>
            <div id="placeholder"></div>
        </div>
        <div id="nav-menu-container"
             :class="{hidden: menuState === 0}">
            <div id="nav-menu"
                 :class="{hidden: menuState !== 1, 'nav-menu': true}">
                <router-link to="/" @click.native="dismiss">
                    {{this.$lang.navHome}}
                </router-link>
                <a @click="categoryClicked">
                    {{this.$lang.navCatalog}}
                </a>
                <router-link to="/support" @click.native="dismiss">
                    {{this.$lang.navSupport}}
                </router-link>
                <router-link to="/blog" @click.native="dismiss">
                    {{this.$lang.navBlog}}
                </router-link>
                <router-link to="/about" @click.native="dismiss">
                    {{this.$lang.navAbout}}
                </router-link>
                <a class="disabled">
                    {{this.$lang.navShop}}
                </a>
                <a @click="langClicked">
                    Language
                </a>
            </div>
            <div id="category-menu"
                 :class="{hidden: menuState !== 2, 'nav-menu': true}">
                <router-link v-for="category in dbData.categories"
                             :key="category.index"
                             :to="`/catalog/${category.index}`"
                             @click.native="dismiss">
                    {{category.title}}
                </router-link>
            </div>
            <div id="lang-menu"
                 :class="{hidden: menuState !== 3, 'nav-menu': true}">
                <a v-for="(lang, index) in langList"
                   :key="lang"
                   @click="changeLanguage(index)">
                    {{lang}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
	import LanguageService from "@/services/LanguageService";

	export default {
		name: "MobileNav",
		props: {
			dbData: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				menuState: 0,
				navTitle: "",
				langList: LanguageService.getNames(),
				throttledScrollTop: 0
			}
		},
		created() {
			window.addEventListener("scroll", this.$throttle(this.onScroll, 75));
		},
		computed: {
			frontPage() {
				return this.$route.meta.index === 0 &&
					this.throttledScrollTop < window.innerHeight;
			},
			showSolid() {
				return !this.frontPage && this.throttledScrollTop > (0.35 * window.innerHeight - 48);
			},
			dropped() {
				return this.frontPage && this.throttledScrollTop < 0.2 * window.innerWidth;
			}
		},
		methods: {
			toggleClicked() {
				let map = [1, 0, 1, 1];
				this.menuState = map[this.menuState] ?? 0;
			},
			categoryClicked() {
				this.menuState = 2;
			},
			langClicked() {
				this.menuState = 3;
			},
			dismiss() {
				this.menuState = 0;
			},
			changeLanguage(id) {
				LanguageService.setLanguage(id);
				this.$router.go(0);
			},
			onScroll() {
				this.throttledScrollTop = window.top.scrollY;
			}
		}
	}
</script>

<style scoped lang="scss">
    #mobile-nav {
        position: fixed;
        z-index: 2;
        width: 100%;
        max-width: 100vw;
        height: 48px;
    }

    #mobile-nav.solid {
        background-color: $p-bg;
    }

    #nav-header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
    }

    #toggle-button, #placeholder {
        width: 48px;
    }

    #toggle-button {
        background-color: transparent;
        height: 48px;
        box-sizing: border-box;
    }

    img {
        position: relative;
        display: inline-block;
        height: 20px;
        top: 14px;
        transition: height 0.5s $bezier, margin-top 0.5s $bezier;
    }

    .dropped img {
        height: calc(8vw - 4px);
        margin-top: calc(7vw - 12px);
    }

    #nav-menu-container {
        position: relative;
        background-color: $p-bg;
        top: -48px;
        padding-top: 48px;
        height: 100vh;
        box-sizing: border-box;
        clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        transition-property: transform, opacity, clip-path;
        transition-duration: 0.5s;
        z-index: -1;

        @include msBad {
            position: absolute;
            top: 0;
            width: 100%;
            clip: rect(0, auto, auto, 0);
        }
    }

    .nav-menu {
        position: absolute;
        top: 48px;
        left: 0;
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        box-sizing: border-box;
        opacity: 1;
        transition-property: transform, opacity;
        transition-duration: 0.5s;
        transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    }

    #nav-menu-container.hidden {
        clip-path: polygon(0% 0%, 0% 0%, 100% 0%, 100% 0%);

        @include msBad {
            clip: rect(0, auto, 0, 0);
        }
    }

    #nav-menu.hidden {
        opacity: 0;
        transform: translateX(-2em);
        pointer-events: none;
    }

    #category-menu.hidden, #lang-menu.hidden {
        opacity: 0;
        transform: translateX(2em);
        pointer-events: none;
    }

    a {
        position: relative;
        height: 48px;
        line-height: 48px;
        padding: 0 32px;
        margin-top: 2px;
        text-align: left;
    }

    a::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 32px;
        right: 32px;
        border-bottom: $solid;
    }

    a.disabled {
        color: $d-fg;
    }
</style>